import { apiConfig } from 'config';

const STATUS_CHECK_INTERVAL_MS = 2000;

/**
 * send http request to initiate blink device LED
 * @param {string} deviceID target device ID
 * @param {boolean} isGa2 whether the device is GA2
 * @param {string} networkElement target device type
 * @param {string} serialId serial ID of the device (required for GA2)
 */
export const blinkDeviceLED = (deviceID, isGa2 = false, networkElement = 'DU', serialId = '') => {
  const url = isGa2 
    ? apiConfig.cmServiceDevicesGA2BlinkDeviceLED(deviceID)
    : apiConfig.cmServiceDevicesBlinkDeviceLED(deviceID);

  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'Content-Type': 'application/json',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'accept-encoding': 'gzip, deflate'
  };

  // GA2 uses different request body
  const raw = isGa2 
    ? JSON.stringify({ 
        "network-element": networkElement
      })
    : JSON.stringify({ blink: 1 });

  var requestOptions = {
    method: 'POST',
    headers: headers,
    body: raw,
    redirect: 'follow'
  };

  return new Promise((resolve, reject) => {
    fetch(url, requestOptions)
      .then((res) => {
        if (res.status !== 202) {
          res.text().then((data) => {
            reject(data);
          });
          return;
        }

        res.json().then((data) => {
          checkBlinkStatus(data.statusQueryGetUri, null, resolve, reject);
        });
      })
      .catch((error) => {
        console.log('LED error: ', error);
        reject(error);
      });
  });
};

/**
 * periodically call query URI to check status until execution is completed
 * @param {string} uri
 * @param {object} data
 * @param {Promise} resolve
 * @param {Promise} reject
 */
const checkBlinkStatus = (uri, data, resolve, reject) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  if (data == null) {
    fetch(uri, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        checkBlinkStatus(uri, data, resolve, reject);
      })
      .catch((error) => {
        console.log(error);
      });
    return;
  }
  console.log('LED runtime status: ', data);
  if (data.runtimeStatus !== 'Pending' && data.runtimeStatus !== 'Running') {
    resolve(data);
    return;
  }

  setTimeout(() => {
    fetch(uri, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        checkBlinkStatus(uri, data, resolve, reject);
      })
      .catch((error) => reject(error));
  }, STATUS_CHECK_INTERVAL_MS);
};
